export default __webpack_public_path__ + "static/media/logo-sendit.ad09df2a.svg";